module.exports = __webpack_public_path__ + "static/media/placeholder.05c61289.png";